import React, { useEffect, useState } from 'react'
import { avatar3, b1, default1 } from '../../../components/icons'
import { useNavigate, useParams } from 'react-router-dom';
import requestRow from '../../../controller/RequestRow';
import axios from 'axios';
import api from '../../../config/Config'
import toast, { Toaster } from 'react-hot-toast';
import { Alert, Pagination, Space } from 'antd';
import {
    Card, Row, Col, Badge, Drawer, List, Input, Button,
    Checkbox
} from "antd";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

import {
    SearchOutlined, FileExcelOutlined, DiffOutlined, SwapOutlined, HomeOutlined, UnorderedListOutlined
} from "@ant-design/icons"

const SellerAccount = () => {
    const theme = useTheme();
    const isMatch = useMediaQuery(theme.breakpoints.down("md"));
    const { id_sellers } = useParams();
    const { transaction_by_id } = useParams();

    const navigate = useNavigate();
    const data = '';

    const regexTelephone = new RegExp('^\\+\\d{1,3}\\d{9}$');
    const regexEmail = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$');

    const [Loading, setLoading] = useState(false);
    const [avatar, setAvatar] = useState('');
    const [phone, setPhone] = useState('');
    const [name, setName] = useState('');
    const [lastname, setLastName] = useState('');
    const [middlename, setMiddlename] = useState('');
    const [email, setEmail] = useState('');
    const [adress, setAddress] = useState('')
    const [minicipal, setMinicipal] = useState('');
    const [gender, setGender] = useState('');
    const [userRoleId, setUserRoleId] = useState('');
    const [userRoleName, setUserRoleName] = useState('');
    const [civilStatus, setCivilStatus] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [placeOfBirth, setPlaceOfBirth] = useState('');
    const [note, setNote] = useState('');
    const [orderType, setOrderType] = useState('');

    // Add telecom fields

    const [telecom, setTelecom] = useState('');
    const [telephone, setTelephone] = useState('');

    // Variables Load elements
    const [province, setPronvince] = useState<requestRow[]>([])
    const [city, setCity] = useState<requestRow[]>([])
    const [minicipality, setMinicipality] = useState<requestRow[]>([])
    const [categoriRole, setCategoriRole] = useState<requestRow[]>([])
    const [sellerLoad, setSellerLoad] = useState<requestRow[]>([])
    const [tva, setTva] = useState<requestRow[]>([])
    const [operator, setOperator] = useState<requestRow[]>([])

    //Load transaction by id 
    const [transactionById, setTransactionById] = useState<requestRow[]>([])

    const [LoadVoucher, setLoadVoucher] = useState<requestRow[]>([])
    const [LoadInventory, setLoadInventory] = useState<requestRow[]>([])
    const [seriesNumber, setSeriesNumber] = useState('')
    const [vouchersValid, setVoucherValid] = useState('')
    const [vouchersUsed, setVouchersUsed] = useState('')
    const [voucherDifference, setVoucherDifference] = useState(0)

    const [sommePins, setSommesPins] = useState('')
    const [sommeTotal, setSommeTotal] = useState('')
    const [sommeAvailablePins, setSommeAvailablePins] = useState('')
    const [sommeDiscount, setSommeDiscount] = useState('')
    const [sommeVatAmount, setSommeVatAmount] = useState('')
    
    const [showAlertDanger, setShowAlertDanger] = useState(false);
    const [showAlertSucess, setShowAlertSucess] = useState(false);
    const [message, setMessage] = useState("");

    //Payement textField

    const [modePaye, setModePaye] = useState('')

    //Paginate
    const [totalPage, setTotalPage] = useState(1);

    useEffect(() => {
        if (sessionStorage.getItem('onktxonktx') == null) {
            navigate('/login')
        }

        loadProvince()
        loadCity()
        loadMinicipality()
        loadCategorie_or_Role()
        loadSeller()
        LoadVoucher_By_Account(1)
        loadTva()
        loadOperator()
        loadTransaction(1)
        loadInventory()
        // Promise.all([loadProvince(), loadCity(), loadMinicipality(), loadCategorie_or_Role(), loadSeller()])
        // .catch((error) => {
        //     if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
        //         toast.error("Pas de connexion internet");
        //     } else {
        //         toast.error(error.response.data.message);
        //     }
        // });
    }, []);


    //Load seller
    function loadSeller() {
        api.getHttpRequest(`/member/load/${id_sellers}`, data, 'GET').then((response) => {
            const json = response.data;

            if (json.status == 200) {
                setName(json.data.name)
                setPhone(json.data.phone)
                setAvatar(json.data.avatar)
                setLastName(json.data.lastname)
                setMiddlename(json.data.middlename)
                setEmail(json.data.email)
                setAddress(json.data.address)
                setMinicipal(json.data.MunicipalityId)
                setGender(json.data.gender)
                setUserRoleId(json.data.UserRoleId)
                setCivilStatus(json.data.civil_status)
                setDateOfBirth(json.data.date_of_birth)
                setPlaceOfBirth(json.data.place_of_birth)
                setUserRoleName(json.data.Role)
            }

        }).catch((error) => {
            if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                toast.error("Please connect your device to the internet");
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        })
    }

    function loadTransaction(page: any) {
        api.getHttpRequest(`/partners/transactions/${id_sellers}?page=${page}`, data, 'GET').then((response) => {

            const json = response.data;
            if (json.status == 200) {
                setTransactionById(json.data.results);

            }
        }).catch((error) => {
            if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                toast.error("Please connect your device to the internet");
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        })
    }

    function loadInventory() {
        api.getHttpRequest(`/partners/transactions-eventory/${id_sellers}`, data, 'GET').then((response) => {

            const json = response.data;
            if (json.status == 200) {
                setLoadInventory(json.data.data);
                setSommesPins(json.data.somme_pins);
                setSommeTotal(json.data.somme_total);
                setSommeAvailablePins(json.data.somme_available_pins);
                setSommeDiscount(json.data.somme_discount);
                setSommeVatAmount(json.data.somme_vat_amount)
            }
        }).catch((error) => {
            if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                toast.error("Please connect your device to the internet");
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        })
    }

    //Load by account

    function LoadVoucher_By_Account(page: any) {
        api.getHttpRequest(`/partners/inventory/series/${id_sellers}?page=${page}`, data, 'GET').then((response) => {
            const json = response.data;
            if (json.status == 200) {
                setLoadVoucher(json.data.rows);
                setSeriesNumber(json.data.series_number)
                setVoucherValid(json.data.count_vouchers_valid)
                setVouchersUsed(json.data.count_vouchers_used)
                setVoucherDifference(json.data.count_vouchers_valid - json.data.count_vouchers_used)

                setTotalPage(json.data.series_number);
            }
        }).catch((error) => {
            if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                toast.error("Please connect your device to the internet");
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        })
    }

    //Load zones
    const loadProvince = async () => {
        api.getHttpRequest("/zone/province/load", data, 'GET').then((response) => {
            const json = response.data;
            if (json.status == 200) {
                setPronvince(json.data);
            }
        }).catch((error) => {
            if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                toast.error("Please connect your device to the internet");
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        })
    }

    const loadCity = async () => {
        api.getHttpRequest("/zone/city/load", data, 'GET').then((response) => {
            const json = response.data;
            if (json.status == 200) {
                setCity(json.data);
            }
        }).catch((error) => {
            // setLoading(false);
            if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                toast.error("Please connect your device to the internet");
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        })
    }

    const loadMinicipality = async () => {
        api.getHttpRequest("/zone/municipality/load", data, 'GET').then((response) => {
            const json = response.data;
            if (json.status == 200) {
                setMinicipality(json.data);
            }
        }).catch((error) => {
            // setLoading(false);
            if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                toast.error("Please connect your device to the internet");
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        })
    }

    const loadCategorie_or_Role = async () => {
        api.getHttpRequest("/parameters/roles/load", data, 'GET').then((response) => {
            const json = response.data;
            if (json.status == 200) {
                setCategoriRole(json.data);
            }
        }).catch((error) => {
            // setLoading(false);
            if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                toast.error("Please connect your device to the internet");
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        })
    }

    const loadTva = async () => {
        api.getHttpRequest("/parameters/constante/load", data, 'GET').then((response) => {
            const json = response.data;
            if (json.status == 200) {
                setTva(json.data);
            }
        }).catch((error) => {
            // setLoading(false);
            if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                toast.error("Please connect your device to the internet");
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        })
    }

    const loadOperator = async () => {
        api.getHttpRequest("/parameters/mobile-operator/load", data, 'GET').then((response) => {
            const json = response.data;
            if (json.status == 200) {
                setOperator(json.data.rows);
            }
        }).catch((error) => {
            // setLoading(false);
            if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                toast.error("Please connect your device to the internet");
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        })
    }

    const handleImageChange = (e: any) => {
        setAvatar(e.target.files[0]);
    };

    // Fonction qui va permettre des charger le city appartir de la province
    const [stateCity, setStateCity] = useState<requestRow[]>([])
    const [stateMinicipality, setStateMinicipality] = useState<requestRow[]>([])
    const GetProvince = (id: any) => {
        const IdProv = city.filter(x => x.PronvinceId === id);
        setStateCity(IdProv)
    }

    const GetCity = (id: any) => {
        const IdCity = minicipality.filter(x => x.CityId === id);
        setStateMinicipality(IdCity)
    }


    const getUsed = (x: any) => {
        if (x == true) return ['badge badge-pill bg-danger', 'Used'];
        if (x == false) return ['badge badge-pill bg-success', 'Not used'];
        return '';
    }

    const getTransfer = (x: any) => {
        if (x == true) return ['badge badge-danger', 'Transferred'];
        if (x == false) return ['badge badge-success', 'Not Transferred'];
        return '';
    }

    const [value, setValue] = useState("Vendor payement mode");

    function handleChange(event: any) {
        setValue(event.target.value);
    }

    // Function pour me permettre en charger mon pannier
    const [idSerie, setIdSerie] = useState('');
    let val: requestRow[] = [];
    const [panierData, setPanierData] = useState<requestRow[]>([]);
    const [panier, setPanier] = useState<requestRow[]>([]);
    let total = 0;
    let rows = document.querySelectorAll("#table1 tr");

    const addToCard = async () => {

        const id = idSerie;
        if (!/^[1-9]\d*$/.test(id)) {
            // Affiche un message d'erreur
            // toast.error("Please enter the series");
            setShowAlertDanger(true)
            setMessage("Please enter the series")
            return;
        }

        api.getHttpRequest(`/partners/find_serie_informations/${idSerie}`, data, 'GET').then((response) => {
            const json = response.data;

            if (json.status == 200) {

                const item: any = panier.find((i) => i.serie === json.data.serie)

                if (json.data.available_pins == 0) {
                    // toast.error('This series has already been assigned');
                    setShowAlertDanger(true)
                    setMessage("This series has already been assigned")
                } else if (item) {
                    // toast.error('This series exists in the cart');
                    setShowAlertDanger(true)
                    setMessage("This series exists in the cart")
                } else {
                    // Sinon, ajoute le produit au panier avec une quantité de 1
                    setPanier([...panier, { ...json.data, quantity: 1 }]);
                    setIdSerie('');
                }


            }

        }).catch((error) => {
            if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                toast.error("Please connect your device to the internet");
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        })
    }

    // Fonction qui retire un produit du panier
    const removeFromCart = (id: any) => {
        const item = panier.find((i) => i.serie === id);

        if (item) {
            if (item.quantity > 1) {
                setPanier(
                    panier.map((i) =>
                        i.id === id ? { ...i, quantity: i.quantity - 1 } : i
                    )
                );
            } else {
                // Sinon, retire le produit du panier
                setPanier(panier.filter((i) => i.serie !== id));
            }
        }
    }


    // Fonction qui calcule le prix total du panier
    const getTotalPrice = () => {
        return panier.reduce(
            (total: any, item: any) => total + parseInt(item.series_available_amount),
            0
        );
    };

    const getAvalaiblePins = () => {
        return panier.reduce(
            (total: any, item: any) => total + parseInt(item.available_pins),
            0
        );
    };


    // Attributes Vouchers
    const Attributed_voucher = async () => {

        let payement_informations: any = [];
        // Vérifie si les variables telecom et phone sont vides ou non
        if (telecom && telephone) {
            // Si elles ne sont pas vides, ajoute-les au tableau
            payement_informations = [telecom, phone];
        }


        let data = JSON.stringify({
            "id_partner": id_sellers,
            "series": panier,
            "mode_payement": value,
            "payement_informations": note,
            "order_type": orderType,
            "sub_total": bigTot,
            "tva": vat_amount,
            "discount": discount_amount,
        });

        setLoading(true);
        if (value === '' || note === '' || orderType === '') {
            toast.error('No fields should be empty, Be sure to check yourTraining');
            setShowAlertDanger(true);
            // setMessage("No fields should be empty, Be sure to check yourTraining")
        } else {
            api.getHttpRequest("/partners/attribute-vouchers", data, 'POST').then((response) => {
                const json = response.data;
                if (json.status == 200) {
                    // toast.success(json.message);
                    
                    setShowAlertSucess(true)
                    setMessage(json.message)
                    loadInventory();
                    setPanier([])
                } else if(json.status == 400)
                {
                    setShowAlertDanger(true)
                    setMessage(json.message)
                } else {
                    // toast.error(json.message);
                    setShowAlertDanger(true)
                    setMessage(json.message)
                }
            }).catch((error) => {
                if (!window.navigator.onLine && !error.response && error.code === "ERR_NETWORK") {
                    setMessage("Please connect your device to the internet");
                    // setMessage("Please connect your device to the internet")
                } else if (error.response && error.response.data && error.response.data.message) {
                    setShowAlertDanger(true)
                    setMessage(error.response.data.message);
                    setPanier([])
                } else {
                    setShowAlertDanger(true)
                    setMessage(error.message);
                    setPanier([])
                }
            })
        }


        setTimeout(() => {
            setLoading(false);
        }, 3000)

    }

    const result = tva.find(({ name }: any) => name === 'Tva')?.value ?? "0";
    const resultDiscount = tva.find(({ name }: any) => name === 'Discount')?.value ?? "0";
    const vat_amount = getTotalPrice() * (parseInt(result) / 100);
    const discount_amount = getTotalPrice() * (parseInt(resultDiscount) / 100);
    const bigTot = getTotalPrice() + vat_amount - discount_amount;

    // get Icons where select = value select
    const getIcon = operator.find(({ name }: any) => name === telecom)?.icon ?? "assets/images/all_mobile_money.jpeg"

    //Card telecom checked
    const [checked, setChecked] = useState(false);
    const handleClick = () => {
        setChecked(!checked);
    };

    return (
        <>
            {/** Start container-fluid */}

            <div className="container-fluid1">

                {/** search-bar and active btn */}
                {/* <div className="row pb-5">
                    <div className="col-lg-8">
                        <div className="header-left">
                            <div className="dashboard_bar">
                                <div className="input-group search-area d-lg-inline-flex">
                                    <div className="input-group-append">
                                        <button className="input-group-text"><i className="mdi mdi-magnify"></i></button>
                                    </div>
                                    <input type="text" className="form-control" placeholder="Search here..." />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-2">
                        <div className="d-flex weather-detail">
                            <span id="invest_status_pan" style={{ backgroundColor: '#1EAAE7', color: 'white' }}><i
                                className="las la-scan"></i> <a id="invest_status">Active</a></span> Status
                        </div>
                    </div>
                </div> */}
                {/** search-bar and active btn */}



                {/** banner */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card stacked-2">
                            <div className="card-header flex-wrap border-0 pb-0 align-items-end profile ">
                                <div className="profile-head">
                                    <div className="photo-content">
                                        <div style={{ backgroundImage: `url(${b1})` }}
                                            className="cover-photo rounded"></div>
                                    </div>
                                    <div className="profile-info">
                                        <div className="profile-photo">
                                            <img src={api.var_.url_avatar + avatar}
                                                className="img-fluid rounded-circle" alt="" />
                                        </div>
                                        <div className="profile-details">
                                            <div className="profile-name px-3 pt-2">
                                                <h4 className="text-primary mb-0 font-weight-500" id="_name">{name}</h4>
                                                <p id="_fonction">{userRoleName}</p>
                                            </div>
                                            <div className="profile-email px-2 pt-2">
                                                <h4 className="text-muted mb-0 font-weight-500 font-16" id="_gender">
                                                    {gender}</h4>
                                                <p id="_phone">{phone}</p>
                                            </div>
                                            <div className="dropdown ms-auto">
                                                <a href="#" className="" data-bs-toggle="dropdown" aria-expanded="true">

                                                </a>

                                                <div className="dropdown user-setting">
                                                    <button className=" dropdown-toggle btn btn-primary sharp border-info"
                                                        type="button" data-toggle="dropdown" aria-expanded="false">
                                                        <i className="ti-more-alt font-20"></i>
                                                    </button>
                                                    <div className="dropdown-menu dropdown-menu-right font-16 ">
                                                        <a className="dropdown-item" href="#"><i
                                                            className="mdi mdi-account-outline font-20"></i> View
                                                            Profile</a>
                                                        <a className="dropdown-item" href="#"><i
                                                            className="mdi mdi-account-multiple-plus-outline font-20"></i>
                                                            Add to btn-close friends</a>
                                                        <a className="dropdown-item" href="#"><i
                                                            className="mdi mdi-plus scale5 font-20"></i> Add to
                                                            group</a>
                                                        <a className="dropdown-item" href="#"><i
                                                            className="mdi mdi mdi-block-helper font-18"></i>
                                                            Block</a>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                {/** banner */}



                <div className="row">

                    {/** main-tabs */}
                    <div className="col-12 seller-tabs">
                        <div>
                            <Toaster
                                position="bottom-right"
                                reverseOrder={false}

                            />
                        </div>
                        <ul className="nav nav-tabs tabs-bordered mt-4 ">
                            {/* <li className="nav-item">
                                <a href="#home-b1" data-toggle="tab" aria-expanded="false" className="nav-link active">
                                    <span className="d-block d-sm-none"><i
                                        className="mdi mdi-home-outline font-18"></i></span>
                                    <span className="d-none d-sm-block"><HomeOutlined className="font-22" />
                                        Home</span>
                                </a>
                            </li> */}
                            <li className="nav-item">
                                <a href="#tansactions_tab" data-toggle="tab" aria-expanded="true" className="nav-link ">
                                    <span className="d-block d-sm-none"><i
                                        className="mdi mdi-swap-vertical font-18"></i></span>
                                    <span className="d-none d-sm-block"><SwapOutlined className="font-22" />
                                        Transactions</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#add_Voucher_tab" data-toggle="tab" aria-expanded="false" className="nav-link">
                                    <span className="d-block d-sm-none"><i
                                        className="mdi mdi-ticket-outline font-18"></i></span>
                                    <span className="d-none d-sm-block">
                                        <DiffOutlined className="font-22" />
                                        Add Vouchers</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#edit_profile" data-toggle="tab" aria-expanded="false" className="nav-link active">
                                    <span className="d-block d-sm-none"><i
                                        className="mdi mdi-account-edit-outline font-18"></i></span>
                                    <span className="d-none d-sm-block"><UnorderedListOutlined className="font-22" /> Inventory</span>
                                </a>
                            </li>
                        </ul>
                    </div> {/** main-tabs */}

                    <div className="col-xl-12">
                        <div className="card stacked-2 seller-account-tab">
                            <div className="row">
                                <div className="col-12">

                                    <div className="tab-content">
                                        <div className="tab-pane " id="home-b1">
                                            <div className="tab-infomation">
                                                <div className="card stacked-2 py-5">
                                                    <div className="row">
                                                        <div className="col-xl-3 col-sm-6 widget-inline-box">
                                                            <div className="single-chart">
                                                                <span
                                                                    className="py-3 border-color-1 rounded-circle border-primary">
                                                                    <svg width="34" height="34" viewBox="0 0 34 34"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M26.9165 1.41669H7.08317C5.58028 1.41669 4.13894 2.01371 3.07623 3.07642C2.01353 4.13912 1.4165 5.58046 1.4165 7.08335V17C1.4165 17.3757 1.56576 17.7361 1.83144 18.0018C2.09711 18.2674 2.45745 18.4167 2.83317 18.4167H9.9165V31.1667C9.91583 31.4376 9.99289 31.7031 10.1385 31.9316C10.2842 32.1601 10.4923 32.342 10.7382 32.4559C10.9847 32.5693 11.2585 32.6096 11.5273 32.5719C11.796 32.5343 12.0482 32.4202 12.254 32.2434L16.2915 28.7867L20.329 32.2434C20.5856 32.4628 20.9122 32.5834 21.2498 32.5834C21.5875 32.5834 21.9141 32.4628 22.1707 32.2434L26.2082 28.7867L30.2457 32.2434C30.5023 32.4628 30.8289 32.5834 31.1665 32.5834C31.3715 32.5819 31.574 32.5385 31.7615 32.4559C32.0074 32.342 32.2155 32.1601 32.3612 31.9316C32.5068 31.7031 32.5838 31.4376 32.5832 31.1667V7.08335C32.5832 5.58046 31.9862 4.13912 30.9234 3.07642C29.8607 2.01371 28.4194 1.41669 26.9165 1.41669ZM4.24984 15.5834V7.08335C4.24984 6.33191 4.54835 5.61124 5.0797 5.07988C5.61105 4.54853 6.33172 4.25002 7.08317 4.25002C7.83462 4.25002 8.55529 4.54853 9.08664 5.07988C9.61799 5.61124 9.9165 6.33191 9.9165 7.08335V15.5834H4.24984ZM29.7498 28.0925L27.129 25.84C26.8724 25.6205 26.5458 25.4999 26.2082 25.4999C25.8705 25.4999 25.5439 25.6205 25.2873 25.84L21.2498 29.2967L17.2123 25.84C16.9557 25.6205 16.6292 25.4999 16.2915 25.4999C15.9538 25.4999 15.6273 25.6205 15.3707 25.84L12.7498 28.0925V7.08335C12.7481 6.08812 12.4842 5.1109 11.9848 4.25002H26.9165C27.668 4.25002 28.3886 4.54853 28.92 5.07988C29.4513 5.61124 29.7498 6.33191 29.7498 7.08335V28.0925ZM26.9165 8.50002C26.9165 8.87574 26.7673 9.23608 26.5016 9.50175C26.2359 9.76743 25.8756 9.91669 25.4998 9.91669H16.9998C16.6241 9.91669 16.2638 9.76743 15.9981 9.50175C15.7324 9.23608 15.5832 8.87574 15.5832 8.50002C15.5832 8.1243 15.7324 7.76396 15.9981 7.49829C16.2638 7.23261 16.6241 7.08335 16.9998 7.08335H25.4998C25.8756 7.08335 26.2359 7.23261 26.5016 7.49829C26.7673 7.76396 26.9165 8.1243 26.9165 8.50002ZM26.9165 14.1667C26.9165 14.5424 26.7673 14.9027 26.5016 15.1684C26.2359 15.4341 25.8756 15.5834 25.4998 15.5834H16.9998C16.6241 15.5834 16.2638 15.4341 15.9981 15.1684C15.7324 14.9027 15.5832 14.5424 15.5832 14.1667C15.5832 13.791 15.7324 13.4306 15.9981 13.165C16.2638 12.8993 16.6241 12.75 16.9998 12.75H25.4998C25.8756 12.75 26.2359 12.8993 26.5016 13.165C26.7673 13.4306 26.9165 13.791 26.9165 14.1667ZM26.9165 19.8334C26.9165 20.2091 26.7673 20.5694 26.5016 20.8351C26.2359 21.1008 25.8756 21.25 25.4998 21.25H16.9998C16.6241 21.25 16.2638 21.1008 15.9981 20.8351C15.7324 20.5694 15.5832 20.2091 15.5832 19.8334C15.5832 19.4576 15.7324 19.0973 15.9981 18.8316C16.2638 18.5659 16.6241 18.4167 16.9998 18.4167H25.4998C25.8756 18.4167 26.2359 18.5659 26.5016 18.8316C26.7673 19.0973 26.9165 19.4576 26.9165 19.8334Z"
                                                                            fill="#858585"></path>
                                                                    </svg>
                                                                </span>
                                                            </div>

                                                            <div className="text-center p-3">
                                                                <h2 className="mt-2">
                                                                    <b>{seriesNumber}</b></h2>
                                                                <p className="text-muted mb-0 font-18">Total series
                                                                    assigned
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div className="col-xl-3 col-sm-6 widget-inline-box">
                                                            <div className="single-chart">
                                                                <span
                                                                    className="py-3 border-color-1 rounded-circle border-success">
                                                                    <svg width="34" height="34" viewBox="0 0 34 34"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M26.9165 1.41669H7.08317C5.58028 1.41669 4.13894 2.01371 3.07623 3.07642C2.01353 4.13912 1.4165 5.58046 1.4165 7.08335V17C1.4165 17.3757 1.56576 17.7361 1.83144 18.0018C2.09711 18.2674 2.45745 18.4167 2.83317 18.4167H9.9165V31.1667C9.91583 31.4376 9.99289 31.7031 10.1385 31.9316C10.2842 32.1601 10.4923 32.342 10.7382 32.4559C10.9847 32.5693 11.2585 32.6096 11.5273 32.5719C11.796 32.5343 12.0482 32.4202 12.254 32.2434L16.2915 28.7867L20.329 32.2434C20.5856 32.4628 20.9122 32.5834 21.2498 32.5834C21.5875 32.5834 21.9141 32.4628 22.1707 32.2434L26.2082 28.7867L30.2457 32.2434C30.5023 32.4628 30.8289 32.5834 31.1665 32.5834C31.3715 32.5819 31.574 32.5385 31.7615 32.4559C32.0074 32.342 32.2155 32.1601 32.3612 31.9316C32.5068 31.7031 32.5838 31.4376 32.5832 31.1667V7.08335C32.5832 5.58046 31.9862 4.13912 30.9234 3.07642C29.8607 2.01371 28.4194 1.41669 26.9165 1.41669ZM4.24984 15.5834V7.08335C4.24984 6.33191 4.54835 5.61124 5.0797 5.07988C5.61105 4.54853 6.33172 4.25002 7.08317 4.25002C7.83462 4.25002 8.55529 4.54853 9.08664 5.07988C9.61799 5.61124 9.9165 6.33191 9.9165 7.08335V15.5834H4.24984ZM29.7498 28.0925L27.129 25.84C26.8724 25.6205 26.5458 25.4999 26.2082 25.4999C25.8705 25.4999 25.5439 25.6205 25.2873 25.84L21.2498 29.2967L17.2123 25.84C16.9557 25.6205 16.6292 25.4999 16.2915 25.4999C15.9538 25.4999 15.6273 25.6205 15.3707 25.84L12.7498 28.0925V7.08335C12.7481 6.08812 12.4842 5.1109 11.9848 4.25002H26.9165C27.668 4.25002 28.3886 4.54853 28.92 5.07988C29.4513 5.61124 29.7498 6.33191 29.7498 7.08335V28.0925ZM26.9165 8.50002C26.9165 8.87574 26.7673 9.23608 26.5016 9.50175C26.2359 9.76743 25.8756 9.91669 25.4998 9.91669H16.9998C16.6241 9.91669 16.2638 9.76743 15.9981 9.50175C15.7324 9.23608 15.5832 8.87574 15.5832 8.50002C15.5832 8.1243 15.7324 7.76396 15.9981 7.49829C16.2638 7.23261 16.6241 7.08335 16.9998 7.08335H25.4998C25.8756 7.08335 26.2359 7.23261 26.5016 7.49829C26.7673 7.76396 26.9165 8.1243 26.9165 8.50002ZM26.9165 14.1667C26.9165 14.5424 26.7673 14.9027 26.5016 15.1684C26.2359 15.4341 25.8756 15.5834 25.4998 15.5834H16.9998C16.6241 15.5834 16.2638 15.4341 15.9981 15.1684C15.7324 14.9027 15.5832 14.5424 15.5832 14.1667C15.5832 13.791 15.7324 13.4306 15.9981 13.165C16.2638 12.8993 16.6241 12.75 16.9998 12.75H25.4998C25.8756 12.75 26.2359 12.8993 26.5016 13.165C26.7673 13.4306 26.9165 13.791 26.9165 14.1667ZM26.9165 19.8334C26.9165 20.2091 26.7673 20.5694 26.5016 20.8351C26.2359 21.1008 25.8756 21.25 25.4998 21.25H16.9998C16.6241 21.25 16.2638 21.1008 15.9981 20.8351C15.7324 20.5694 15.5832 20.2091 15.5832 19.8334C15.5832 19.4576 15.7324 19.0973 15.9981 18.8316C16.2638 18.5659 16.6241 18.4167 16.9998 18.4167H25.4998C25.8756 18.4167 26.2359 18.5659 26.5016 18.8316C26.7673 19.0973 26.9165 19.4576 26.9165 19.8334Z"
                                                                            fill="#858585"></path>
                                                                    </svg>
                                                                </span>
                                                            </div>

                                                            <div className="text-center p-3">
                                                                <h2 className="mt-2"><i
                                                                    className="text-teal mdi mdi-airplay mr-2"></i>
                                                                    <b>{vouchersValid}</b></h2>
                                                                <p className="text-muted mb-0 font-18">Total number
                                                                    of vouchers</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-xl-3 col-sm-6 widget-inline-box">
                                                            <div className="single-chart">
                                                                <span
                                                                    className="py-3 border-color-1 rounded-circle  border-info">
                                                                    <svg width="34" height="34" viewBox="0 0 34 34"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M32.3668 9.72969C30.9793 6.78884 28.782 4.31932 26.0137 2.58667C22.1634 0.18354 17.6028 -0.579886 13.1815 0.442442C8.7603 1.45813 4.99628 4.14008 2.59315 7.9904C0.183379 11.8407 -0.580047 16.3947 0.44228 20.8226C1.46461 25.2438 4.14656 29.0079 7.99024 31.411C10.6987 33.1038 13.8056 34 16.9854 34H17.1912C20.3577 33.9602 23.438 33.0441 26.1067 31.3579C26.8834 30.8666 27.1091 29.8443 26.6178 29.0676C26.1266 28.2909 25.1043 28.0652 24.3276 28.5564C22.1833 29.9173 19.7005 30.6542 17.1514 30.6874C14.5358 30.7206 11.98 29.997 9.74944 28.6095C6.64927 26.6711 4.49176 23.644 3.67522 20.0857C2.85869 16.5275 3.46943 12.8631 5.40787 9.76288C9.40424 3.37001 17.8617 1.4183 24.2545 5.41467C26.4851 6.80875 28.2509 8.79366 29.3662 11.157C30.4549 13.4605 30.8797 16.0163 30.5943 18.539C30.4947 19.4484 31.1453 20.2716 32.0614 20.3712C32.9709 20.4708 33.794 19.8202 33.8936 18.9041C34.2455 15.7641 33.7144 12.5909 32.3668 9.72969Z"
                                                                            fill="#2BC155"></path>
                                                                        <path
                                                                            d="M22.4914 11.2377L14.4846 19.2445L11.5169 16.2768C10.8663 15.6262 9.81732 15.6262 9.16669 16.2768C8.51605 16.9274 8.51605 17.9764 9.16669 18.6271L13.3095 22.7699C13.6348 23.0952 14.0597 23.2545 14.4846 23.2545C14.9095 23.2545 15.3345 23.0952 15.6598 22.7699L24.8351 13.588C25.4857 12.9373 25.4857 11.8883 24.8351 11.2377C24.1844 10.5937 23.1354 10.5937 22.4914 11.2377Z"
                                                                            fill="#2BC155"></path>
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                            <div className="text-center p-3">
                                                                <h2 className="mt-2"><i
                                                                    className="text-info mdi mdi-ticket mr-2"></i>
                                                                    <b>{voucherDifference}</b></h2>
                                                                <p className="text-muted mb-0 font-18">Vouchers
                                                                    valid
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div className="col-xl-3 col-sm-6">
                                                            <div className="single-chart">
                                                                <span
                                                                    className="py-3 border-color-1 rounded-circle  border-danger">
                                                                    <svg width="34" height="34" viewBox="0 0 34 34"
                                                                        fill="none"
                                                                        xmlns="http://www.w3.org/2000/svg">
                                                                        <g clipPath="url(#clip0)">
                                                                            <path
                                                                                d="M32.3733 9.72855C30.9854 6.78675 28.7873 4.31644 26.0182 2.58323C22.1666 0.179327 17.6112 -0.584345 13.1819 0.438311C8.75922 1.45433 4.99399 4.13714 2.59008 7.9887C0.179532 11.8403 -0.58414 16.3957 0.438516 20.825C1.46117 25.2477 4.14399 29.0129 7.98891 31.4168C10.6983 33.1102 13.8061 34.0067 16.987 34.0067H17.1928C20.3604 33.9668 23.4416 33.0504 26.1112 31.3637C26.8881 30.8723 27.1139 29.8496 26.6225 29.0727C26.1311 28.2957 25.1084 28.07 24.3315 28.5614C22.1866 29.9227 19.703 30.6598 17.153 30.693C14.5366 30.7262 11.9799 30.0024 9.74867 28.6145C6.6475 26.6754 4.4893 23.6473 3.6725 20.0879C2.8557 16.5153 3.46664 12.8496 5.4057 9.74847C9.40336 3.35355 17.8635 1.4012 24.2584 5.39886C26.4897 6.79339 28.2561 8.77894 29.3717 11.143C30.4608 13.4473 30.8858 16.0039 30.6002 18.5274C30.5006 19.4371 31.1514 20.2606 32.0678 20.3602C32.9776 20.4598 33.801 19.809 33.9006 18.8926C34.2526 15.7649 33.7213 12.5907 32.3733 9.72855Z"
                                                                                fill="#FF2E2E"></path>
                                                                            <path
                                                                                d="M22.7647 11.2359C22.114 10.5852 21.0647 10.5852 20.414 11.2359L17.0007 14.6559L13.5874 11.2426C12.9366 10.5918 11.8874 10.5918 11.2366 11.2426C10.5858 11.8934 10.5858 12.9426 11.2366 13.5934L14.6499 17.0066L11.2366 20.4199C10.5858 21.0707 10.5858 22.1199 11.2366 22.7707C11.562 23.0961 11.987 23.2555 12.412 23.2555C12.837 23.2555 13.262 23.0961 13.5874 22.7707L17.0007 19.3574L20.414 22.7707C20.7394 23.0961 21.1644 23.2555 21.5894 23.2555C22.0144 23.2555 22.4394 23.0961 22.7647 22.7707C23.4155 22.1199 23.4155 21.0707 22.7647 20.4199L19.3515 17L22.7647 13.5867C23.4155 12.9359 23.4155 11.8867 22.7647 11.2359Z"
                                                                                fill="#FF2E2E"></path>
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0">
                                                                                <rect width="34" height="34"
                                                                                    fill="white"></rect>
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                </span>
                                                            </div>
                                                            <div className="text-center p-3">
                                                                <h2 className="mt-2"><i
                                                                    className="text-info mdi mdi-ticket mr-2"></i>
                                                                    <b>{vouchersUsed}</b></h2>
                                                                <p className="text-muted mb-0 font-18">Invalid
                                                                    Vouchers

                                                                </p>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="card-box border-0 reseller-distributer">

                                                        <div className="table-responsive">
                                                            <table
                                                                className="table header-border table-responsive-sm tbl-common">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Serial #</th>
                                                                        <th>Total vouchers</th>
                                                                        <th>Value</th>
                                                                        <th>Used</th>
                                                                        <th>Available</th>
                                                                        <th>Distributor</th>
                                                                        <th>Attributed At
                                                                        </th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody id="tab_">
                                                                    {
                                                                        LoadVoucher.map((item, i) => (
                                                                            <tr key={i}>
                                                                                {/* <td className="serial"><a href="">{item.id}</a></td> */}
                                                                                <td>{item.series}</td>
                                                                                <td>{item.type}</td>
                                                                                <td>{item.count}</td>
                                                                                <td><span className="btn btn-sm btn-success light btn-radius">{item.amount}</span></td>
                                                                                <td style={{ width: 15 }}>
                                                                                    <span className={getUsed(item.voucher_used)[0]}>{getUsed(item.voucher_used)[1]}</span>
                                                                                </td>

                                                                                <td><span className={getTransfer(item.status)[0]}><i
                                                                                    className="fa fa-circle text-success me-1"></i>{getTransfer(item.is_transfered)[1]}</span>

                                                                                </td>
                                                                                <td>{item.date}</td>
                                                                            </tr>
                                                                        ))
                                                                    }


                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <nav>
                                                            <div className="pagination pagination-lg mb-0">
                                                                <Pagination
                                                                    style={{
                                                                        paddingTop: 10

                                                                    }}
                                                                    responsive
                                                                    pageSizeOptions={[10, 20, 30, 40]}
                                                                    pageSize={10}
                                                                    total={totalPage}
                                                                    onChange={(page: any) => {
                                                                        LoadVoucher_By_Account(page)
                                                                    }}
                                                                />
                                                            </div>
                                                        </nav>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="tab-pane" id="tansactions_tab">

                                            <div className="col-md-12">
                                                <div className="card-1">

                                                    <div className="card-body">
                                                        <div>
                                                            <h2 className="header-title pb-0 font-30 border-none">My transactions
                                                            </h2>
                                                            <div style={{ display: 'flex', marginLeft: 10, paddingBottom: 10 }}>
                                                                <label style={{
                                                                    backgroundColor: '#4920E9',
                                                                    height: 20,
                                                                    width: 6,
                                                                    borderRadius: 10
                                                                }}></label>
                                                                <strong style={{ paddingLeft: 2 }}>List of all my transactions</strong>
                                                            </div>
                                                        </div>
                                                        <div className="table-responsive mt-3">
                                                            <table id="table1"
                                                                className="table table-bordered table-striped verticle-middle table-responsive-sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">#</th>
                                                                        <th scope="col">Serie</th>
                                                                        <th scope="col">Product</th>
                                                                        {/* <th scope="col">Vouchers Used</th> */}
                                                                        <th scope="col">Status</th>
                                                                        <th scope="col">Finance <Badge count={5} size="small" style={{ backgroundColor: '#52c41a', marginLeft: 10, cursor: 'pointer' }}></Badge></th>
                                                                        <th scope="col">Surplier Amount <br />
                                                                            from used
                                                                        </th>
                                                                        <th scope="col">Surplier Paid</th>
                                                                        <th scope="col">Surplier Unpaid</th>
                                                                        <th scope="col">Total Amount paid <br />
                                                                            / Collected
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                {/* {panierData.length > 0 && ( */}

                                                                <tbody id="tpanier">

                                                                    {
                                                                        LoadInventory.map((item, i) => (
                                                                            <>
                                                                                <tr key={i} style={{ borderBottom: '1px solid #E8E8E8' }}>
                                                                                    {/* <td>{index + 1}</td> */}
                                                                                    <td>{i+1}</td>
                                                                                    <td>
                                                                                        {item.series}
                                                                                    </td>
                                                                                    <td><span style={{ display: 'flex' }}> <h6 style={{ marginRight: 5 }}>Currenry:</h6>{item.currency}.{item.amount_selling_prince}</span> <br />
                                                                                        <h6>Pins : </h6>
                                                                                        {item.pins} <br />
                                                                                        <h6>Total seies Amount <br /> Value:</h6>{item.currency}.{parseInt(item.pins) * parseInt(item.amount_selling_prince)}
                                                                                    </td>
                                                                                    {/* <td><span className="badge badge-success">{item.used}</span></td> */}
                                                                                    <td>
                                                                                        <span style={{ display: 'flex', marginTop: 0 }}> <h6 style={{ marginRight: 5 }}>Used:</h6>{item.status_used}</span><br />
                                                                                        <span style={{ display: 'flex' }}> <h6 style={{ marginRight: 5 }}>Assigned:</h6>{item.status_asigned}</span><br />
                                                                                        <span style={{ display: 'flex' }}> <h6 style={{ marginRight: 5 }}>Available Pins:</h6>{item.available_pins}</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <span style={{ display: 'flex' }}> <h6 style={{ marginRight: 5 }}>Used:</h6>{item.currency}.{item.finance_amount_used}</span> <br />
                                                                                        <h6>Paid surplier: </h6>
                                                                                        {item.finance_amount_paid_surplier} <br />
                                                                                        <h6>Unpaid:</h6>{item.currency}.{item.finance_amount_unpaid}
                                                                                    </td>
                                                                                    <td><span style={{ display: 'flex', fontSize: 18 }}>{item.currency}.{item.finance_amount_used}</span></td>
                                                                                    <td><span style={{ display: 'flex', fontSize: 18 }}>{item.currency}.{item.finance_amount_paid_surplier}</span></td>
                                                                                    <td><span style={{ display: 'flex', fontSize: 18 }}>{item.currency}.{item.finance_amount_unpaid}</span></td>
                                                                                    <td><span style={{ display: 'flex', fontSize: 18 }}>{item.currency}.{item.total_amount_pay_collect}
                                                                                        <Badge count={5} size="small" style={{ backgroundColor: '#52c41a', marginLeft: 10, cursor: 'pointer' }}></Badge>
                                                                                    </span></td>
                                                                                    <td>
                                                                                        <span style={{ cursor: 'pointer' }}>
                                                                                            <div data-bs-toggle="tooltip" data-placement="top" title="Close"
                                                                                                onClick={() => removeFromCart(1)} >
                                                                                                <i className="fas fa-times color-danger"></i>
                                                                                            </div>
                                                                                        </span>
                                                                                    </td>
                                                                                </tr>
                                                                            </>
                                                                        ))
                                                                    }

                                                                </tbody>

                                                                <tfoot style={{ backgroundColor: '#CFE1FD' }}>
                                                                    <th colSpan={3}><span><h5 style={{ fontSize: 26 }}>Total: </h5></span></th>
                                                                    <th colSpan={2}><span style={{ fontSize: 20 }}>Total Available Pins : <br /><h5>{sommePins}</h5></span></th>

                                                                    <th><span style={{ fontSize: 20 }}>Tsh: {sommeTotal}</span></th>
                                                                    <th colSpan={2}><span style={{ fontSize: 20 }}>Tsh: {sommeTotal}
                                                                    <Badge count={5} size="small" style={{ backgroundColor: 'red', marginLeft: 10, cursor: 'pointer' }}>
                                                                    
                                                                    </Badge>
                                                                    </span></th>
                                                                    
                                                                    
                                                                    <th colSpan={3}><span>Total:{sommeTotal}</span><br />
                                                                        <span>VAT: Tsh {sommeVatAmount}</span><br />
                                                                        <span>Discount: Tsh {sommeDiscount}</span><br />
                                                                        <span>Final total</span><br />
                                                                        <h6 style={{ fontSize: 16 }}>Tsh.{sommeTotal}</h6>
                                                                    </th>
                                                                </tfoot>

                                                                {/* )} */}
                                                            </table>
                                                        </div>
                                                        {/* <div className="row">
                                                    <div className="col-lg-3 col-sm-3"> </div>
                                                    <div className="col-lg-9 col-sm-9 ms-auto">
                                                        
                                                    </div>

                                                </div> */}



                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="tab-pane  pb-5" id="add_Voucher_tab">
                                            <div className="col-sm-12">
                                                <div className="row">
                                                    <div className="col-md-3" style={{ display: 'flex' }}>
                                                        <div className="mb-0">
                                                            <label>vouchers</label>
                                                            <input id="allvouchers" type="text"
                                                                className="form-control input-default "
                                                                placeholder="Enter the series" name='idSerie' value={idSerie} onChange={(e) => { setIdSerie(e.target.value) }} />
                                                        </div>
                                                        <div className="mb-0 " style={{ marginTop: 20, marginLeft: 5 }}>
                                                            <button type="button"
                                                                style={{ width: '100px', height: 40, paddingTop: 2 }}
                                                                id="btn_save_vouchers"
                                                                className="btn btn-primary agree-link" onClick={addToCard}>Send</button>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-8'>
                                                    {/* <label style={{color:'white'}}>vouchers</label> */}
                                                    <Space direction="vertical" style={{ width: '100%' }}>
                                                    {
                                                    showAlertSucess && 
                                                    <Alert type="success" message={message}  showIcon closable/>
                                                        } {
                                                            showAlertDanger && 
                                                            <Alert type="error" message={message}  showIcon closable/>
                                                        } 
                                                    </Space>
                                                        
                                                       
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="card-1">
                                                            <div className="card-body">
                                                                <div className="table-responsive mt-3">
                                                                    <table id="table1"
                                                                        className="table table-bordered table-striped verticle-middle table-responsive-sm" style={{ border: 0 }}>
                                                                        <thead>
                                                                            <tr>
                                                                                <th scope="col">Qte</th>
                                                                                <th scope="col">Serie</th>
                                                                                <th scope="col">Nomber vouchers</th>
                                                                                {/* <th scope="col">Vouchers Used</th> */}
                                                                                <th scope="col">Status</th>
                                                                                <th scope="col">Aeries Available Amount</th>
                                                                                <th scope="col">Total Amount <br />
                                                                                    to Pay / Collect
                                                                                </th>

                                                                            </tr>
                                                                        </thead>
                                                                        {/* {panierData.length > 0 && ( */}

                                                                        <tbody id="tpanier">
                                                                            {panier.map((item: any, index: number) => (

                                                                                <tr key={item.id} style={{ borderBottom: '1px solid #E8E8E8' }}>
                                                                                    <td>{index + 1}</td>
                                                                                    {/* <td>{item.quantity}</td> */}
                                                                                    <td>{item.serie} <span className="badge badge-success pl-2">{item.type}</span></td>
                                                                                    <td><span style={{ display: 'flex' }}> <h6 style={{ marginRight: 5 }}>Currenry:</h6>{item.currency}.{item.amount_selling_prince}</span> <br />
                                                                                        <h6>Available Pins : </h6>
                                                                                        {item.available_pins} <br />
                                                                                        <h6>Customer Selling Price:</h6>{item.currency}.{item.amount_selling_prince}
                                                                                    </td>
                                                                                    {/* <td><span className="badge badge-success">{item.used}</span></td> */}
                                                                                    <td>
                                                                                        <span style={{ display: 'flex' }}> <h6 style={{ marginRight: 5 }}>Pins:</h6>{item.status_available}</span><br />
                                                                                        <span style={{ display: 'flex', marginTop: 0 }}> <h6 style={{ marginRight: 5 }}>Used:</h6>{item.status_used}</span><br />
                                                                                        <span style={{ display: 'flex' }}> <h6 style={{ marginRight: 5 }}>Assigned:</h6>{item.status_asigned}</span><br />
                                                                                        <span style={{ display: 'flex' }}> <h6 style={{ marginRight: 5 }}>Available Pins:</h6>{item.available_pins}</span>
                                                                                    </td>
                                                                                    <td><span style={{ display: 'flex', fontSize: 18 }}>{item.currency}.{item.series_available_amount}</span></td>
                                                                                    <td><span style={{ display: 'flex', fontSize: 18 }}>{item.currency}.{item.series_available_amount}</span></td>
                                                                                    <td>
                                                                                        <span style={{ cursor: 'pointer' }}>
                                                                                            <div data-bs-toggle="tooltip" data-placement="top" title="Close"
                                                                                                onClick={() => removeFromCart(item.serie)} >
                                                                                                <i className="fas fa-times color-danger"></i>
                                                                                            </div>
                                                                                        </span>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                        <tfoot style={{ backgroundColor: '#CFE1FD' }}>
                                                                            <th colSpan={2}><span><h5 style={{ fontSize: 26 }}>Total: </h5></span></th>
                                                                            <th colSpan={2}><span style={{ fontSize: 20 }}>Total Available Pins : <br /><h5>{getAvalaiblePins()}</h5></span></th>

                                                                            <th><span style={{ fontSize: 20 }}>Tsh: {getTotalPrice()}</span></th>
                                                                            <th colSpan={2}><span style={{ fontSize: 20 }}>Tsh: {getTotalPrice()}</span></th>
                                                                        </tfoot>

                                                                        {/* )} */}
                                                                    </table>
                                                                </div>


                                                                <div className="row">

                                                                    <div className="col-lg-3 col-sm-3">
                                                                    </div>
                                                                    <div className="col-lg-6 col-sm-9 ms-auto">
                                                                        <table className="table table-clear" id="tbodypanier">
                                                                            {panier.length > 0 && (
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td className="left"><strong>To Pay / Collect <br /><h6>Sub Total</h6></strong></td>
                                                                                        <td className="right"><h6 style={{ fontSize: 18 }}>Tsh:{getTotalPrice()}</h6></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="left"><strong>Discount ({resultDiscount} %)</strong></td>
                                                                                        <td className="right">{discount_amount} Tsh</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="left"><strong>VAT ({result} %)</strong></td>
                                                                                        <td className="right">{vat_amount} Tsh</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="left"><strong>Gros Total</strong></td>
                                                                                        <td className="right"><strong><h6 style={{ fontSize: 18 }}>Tsh:{bigTot}</h6></strong><br />
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="left">
                                                                                            <strong>Note <span style={{ color: 'red' }}>*</span></strong>
                                                                                            <textarea className="form-control" onChange={(e) => { setNote(e.target.value) }}></textarea>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="left">
                                                                                            <strong>Order Type <span style={{ color: 'red' }}>*</span></strong>
                                                                                            <select className="form-control" id="payement-mode" name='orderType' value={orderType} onChange={(e) => { setOrderType(e.target.value) }}>
                                                                                                <option value="">Select</option>
                                                                                                <option value="Physical in Office">Physical in Office</option>
                                                                                                <option value="On Phone">On Phone</option>
                                                                                                <option value="Via an email">Via an email</option>
                                                                                                <option value="Letter">Letter</option>
                                                                                            </select>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className="left ">
                                                                                            <strong>Payement mode <span style={{ color: 'red' }}>*</span></strong>

                                                                                            <input type='text' className="form-control" id="payement-mode" name='value' value={value} onChange={handleChange} />


                                                                                            <div className="mt-1 col-sm-12">
                                                                                                <div className="mt-4 ">


                                                                                                    {!Loading && (
                                                                                                        <button type="button"
                                                                                                            id="btn_save_vouchers"
                                                                                                            className="btn btn-primary agree-link" onClick={() => { Attributed_voucher() }}>Add</button>
                                                                                                    )}

                                                                                                    {Loading && (

                                                                                                        <button type="button" className="btn btn-primary agree-link" disabled

                                                                                                        >
                                                                                                            <i className="fa fa-spinner fa-spin fa-3x  fa-lg" style={{ fontSize: 15 }}></i> <span>Processing...</span>
                                                                                                        </button>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>

                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>

                                                                            )}
                                                                        </table>
                                                                        {/* <div className="mb-3 col-md-12">
                                                                            <label>Payement mode </label>
                                                                            <select className="form-control" id="payement-mode" name='value' value={value} onChange={handleChange}>
                                                                                <option value="">Select</option>
                                                                                <option value="mobile_Payement">Mobile payement</option>
                                                                                <option value="cash0">Cash</option>
                                                                                <option value="credit_Card">Credit Card</option>
                                                                                <option value="payNext">Pay on Next Order</option>
                                                                                <option value="back_to_collecte_sale">Back to collecte sale</option>
                                                                            </select>
                                                                        </div>
                                                                        {value === "mobile_Payement" && (
                                                                            <div id="mobile_Payement" className="hide col-sm-12">
                                                                                <div className="row ">
                                                                                    <Card onClick={handleClick} style={{ cursor: 'pointer' }}>
                                                                                        <Checkbox checked={checked}>
                                                                                            <img className="col-lg-6"
                                                                                                src={getIcon} />
                                                                                        </Checkbox>

                                                                                    </Card>

                                                                                    <div className="mb-3 col-md-12 pt-2">
                                                                                        <label>Telecom </label>
                                                                                        <select className="form-control" name='telecom' value={telecom} onChange={(e) => { setTelecom(e.target.value) }}
                                                                                            id="mode">
                                                                                            <option value="">Select
                                                                                            </option>
                                                                                            {
                                                                                                operator.map((item, i) => (
                                                                                                    <option key={i} value={item.name}>
                                                                                                        {item.name}</option>
                                                                                                ))
                                                                                            }

                                                                                        </select>
                                                                                    </div>
                                                                                    <div className="mb-3 col-md-12">
                                                                                        <label>Phone number </label>
                                                                                        <input type="phone"
                                                                                            className="form-control" id=""
                                                                                            placeholder="" name='telephone' value={telephone} onChange={(e) => setTelephone(e.target.value)} />
                                                                                    </div>
                                                                                    <div className="mb-3 col-md-12">

                                                                                        {!Loading && (
                                                                                            <button type="button"
                                                                                                style={{ width: '100px' }}
                                                                                                id="btn_save_vouchers"
                                                                                                className="btn btn-primary agree-link" onClick={() => { Attributed_voucher() }}>Pay</button>
                                                                                        )}

                                                                                        {Loading && (

                                                                                            <button type="button" className="btn btn-primary agree-link" disabled>
                                                                                                <i className="fa fa-spinner fa-spin fa-3x  fa-lg" style={{ fontSize: 25 }}></i> <span>Ongoing processing...</span>
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        {value === "cash0" && (
                                                                            <div id="cash0" className="hide col-sm-12">
                                                                                <div className="mb-3 ">


                                                                                    {!Loading && (
                                                                                        <button type="button"
                                                                                            style={{ width: '100px' }}
                                                                                            id="btn_save_vouchers"
                                                                                            className="btn btn-primary agree-link" onClick={() => { Attributed_voucher() }}>Save</button>
                                                                                    )}

                                                                                    {Loading && (

                                                                                        <button type="button" className="btn btn-primary agree-link" disabled>
                                                                                            <i className="fa fa-spinner fa-spin fa-3x  fa-lg" style={{ fontSize: 25 }}></i> <span>Ongoing processing...</span>
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        {value === "credit_Card" && (
                                                                            <div id="credit_Card"
                                                                                className="hide col-sm-12">
                                                                                <div className="mb-3">
                                                                                    <img src="assets/images/payement_card.png"
                                                                                        alt="" />
                                                                                </div>

                                                                                <div className="mb-3">
                                                                                    <label>Card type </label>
                                                                                    <select className="form-control"
                                                                                        id="mode">
                                                                                        <option value="">Select</option>
                                                                                        <option value="Master Card">
                                                                                            Master Card</option>
                                                                                        <option value="Visa">Visa
                                                                                        </option>
                                                                                        <option value="Discover">
                                                                                            Discover</option>
                                                                                        <option
                                                                                            value="American Express">
                                                                                            American Express</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className="mb-3">
                                                                                    <label>CardHolder name </label>
                                                                                    <input type="text"
                                                                                        className="form-control" id=""
                                                                                        placeholder="" />
                                                                                </div>
                                                                                <div className="mb-3">
                                                                                    <label>Card Number </label>
                                                                                    <input type="number"
                                                                                        className="form-control" id=""
                                                                                        placeholder="" />
                                                                                </div>
                                                                                <div className="mb-3">
                                                                                    <label>Expire date </label>
                                                                                    <input type="text"
                                                                                        className="form-control" id=""
                                                                                        placeholder="Expire (MM/yy)" />
                                                                                </div>
                                                                                <div className="mb-3">
                                                                                    <label>CVV </label>
                                                                                    <input type="number"
                                                                                        className="form-control" id=""
                                                                                        placeholder="" />
                                                                                </div>
                                                                                <div className="mb-3 ">
                                                                                    <button type="button"
                                                                                        style={{ width: '100px' }}
                                                                                        id="btn_save_vouchers"
                                                                                        className="btn btn-primary agree-link">Pay</button>
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        {value === "payNext" && (
                                                                            <div id="payNext" className="hide col-sm-12">
                                                                                <div className="mb-3 ">
                                                                                    <button type="button"
                                                                                        style={{ width: '100px' }}
                                                                                        id="btn_save_vouchers"
                                                                                        className="btn btn-primary agree-link">Save</button>
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        {value === "back_to_collecte_sale" && (
                                                                            <div id="back_to_collecte_sale"
                                                                                className="hide col-sm-12">
                                                                                <div className="mb-3 ">
                                                                                    <button type="button"
                                                                                        style={{ width: '100px' }}
                                                                                        id="btn_save_vouchers"
                                                                                        className="btn btn-primary agree-link">Save</button>
                                                                                </div>
                                                                            </div>
                                                                        )} */}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="tab-pane active" id="edit_profile">

                                            <div className="col-md-12">
                                                <div className="card-1">
                                                    <div className="card-body">
                                                        <div>
                                                            <h2 className="header-title pb-0 font-30 border-none">My Inventory
                                                            </h2>
                                                            <div style={{ display: 'flex', marginLeft: 10, paddingBottom: 10 }}>
                                                                <label style={{
                                                                    backgroundColor: 'red',
                                                                    height: 20,
                                                                    width: 6,
                                                                    borderRadius: 10
                                                                }}></label>
                                                                <strong style={{ paddingLeft: 2 }}>List of all my Inventory</strong>
                                                            </div>
                                                        </div>
                                                        <div className="table-responsive mt-3">
                                                            <table id="table1"
                                                                className="table table-bordered table-striped verticle-middle table-responsive-sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">#</th>
                                                                        <th scope="col">Inventory Series</th>
                                                                        <th scope="col">Dominations</th>
                                                                        {/* <th scope="col">Vouchers Used</th> */}
                                                                        <th scope="col">Status</th>
                                                                        <th scope="col">Series available Amount</th>
                                                                        <th scope="col">Order Type</th>
                                                                        <th scope="col">Total Amount <br />
                                                                            to Pay / Collect
                                                                        </th>

                                                                    </tr>
                                                                </thead>
                                                                {/* {panierData.length > 0 && ( */}

                                                                <tbody id="tpanier">

                                                                    {
                                                                        LoadInventory.map((item, i) => (
                                                                            <tr style={{ borderBottom: '1px solid #E8E8E8' }}>
                                                                                <td>{i + 1}</td>
                                                                                <td>{item.series}</td>
                                                                                <td><span style={{ display: 'flex' }}> <h6 style={{ marginRight: 5 }}>Currenry:</h6>{item.currency}.{item.amount_selling_prince}</span> <br />
                                                                                    <h6>Available Pins : </h6>
                                                                                    {item.pins} <br />
                                                                                    <h6>Customer Selling Price:</h6>{item.currency}.{item.amount_selling_prince}
                                                                                </td>
                                                                                {/* <td><span className="badge badge-success">{item.used}</span></td> */}
                                                                                <td>
                                                                                    <span style={{ display: 'flex' }}> <h6 style={{ marginRight: 5 }}>Pins:</h6>{item.pins}</span><br />
                                                                                    <span style={{ display: 'flex', marginTop: 0 }}> <h6 style={{ marginRight: 5 }}>Used:</h6>{item.status_used}</span><br />
                                                                                    <span style={{ display: 'flex' }}> <h6 style={{ marginRight: 5 }}>Assigned:</h6>{item.status_asigned}</span><br />
                                                                                    <span style={{ display: 'flex' }}> <h6 style={{ marginRight: 5 }}>Available Pins:</h6>{item.available_pins}</span>
                                                                                </td>
                                                                                <td><span style={{ display: 'flex', fontSize: 18 }}>{item.currency}.{item.series_available_amount}</span></td>
                                                                                <td><span style={{ display: 'flex', fontSize: 18 }}>{item.order_type}</span></td>
                                                                                <td>{item.currency}.{item.total_amount_pay_collect}</td>
                                                                                <td>
                                                                                    <span style={{ cursor: 'pointer' }}>
                                                                                        <div data-bs-toggle="tooltip" data-placement="top" title="Close"
                                                                                            onClick={() => removeFromCart(1)} >
                                                                                            <i className="fas fa-times color-danger"></i>
                                                                                        </div>
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    }


                                                                </tbody>

                                                                <tfoot style={{ backgroundColor: '#CFE1FD' }}>
                                                                    <th colSpan={2}><span><h5 style={{ fontSize: 26 }}>Total: </h5></span></th>
                                                                    <th colSpan={2}><span >Total Available Pins : <br /><h5>{sommeAvailablePins}</h5></span></th>

                                                                    <th colSpan={2}><span >Total Available Pins : <br /><h5>{sommeTotal}</h5></span></th>
                                                                    <th colSpan={2}><span>Total:{sommeTotal}</span><br />
                                                                        <span>VAT: Tsh {sommeVatAmount}</span><br />
                                                                        <span>Discount: Tsh {sommeDiscount}</span><br />
                                                                        <span>Final total</span><br />
                                                                        <h6 style={{ fontSize: 16 }}>Tsh.{sommeTotal}</h6>
                                                                    </th>
                                                                </tfoot>

                                                                {/* )} */}
                                                            </table>
                                                        </div>
                                                        {/* <div className="row">
                                                    <div className="col-lg-3 col-sm-3"> </div>
                                                    <div className="col-lg-9 col-sm-9 ms-auto">
                                                        
                                                    </div>

                                                </div> */}




                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>



            {/** end container-fluid */}


            {/** add new seller Modal */}
            <div className="modal fade" id="add_new_seller" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Add or Update reseller </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="alert alert-info" role="alert">
                                Before creating a reseller account you must make sure you know the person well, especially their
                                real identity, have their photo and physical address and must be able to assume the role of
                                seller of Tiva products.
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <input type="hidden" id="id" value="00" />
                                    <div className="mb-3 col-md-8">
                                        <label className="form-label">Fullname</label>
                                        <input type="text" className="form-control" placeholder="" id="fullname" />
                                    </div>
                                    <div className="mb-3 col-md-4">
                                        <label className="form-label">Category</label>
                                        <select className="form-control" id="categorie">
                                            <option value="">Select category</option>
                                            <option value="23f07d9b335f7d9bc34f4">Supervisor</option>
                                            <option value="637d9bc35f7d9bc35fa">Agent</option>
                                            <option value="63f07d9bc35f7d9bc35fa">Dealer</option>
                                            <option value="637d9bc35df7d9bc35fa">Distributor</option>
                                            <option value="4637d9bc35df7d9bc35fa23">Vendor</option>
                                        </select>
                                    </div>
                                    <div className="mb-3 col-md-4">
                                        <label className="form-label">Gender</label>
                                        <select className="form-control" id="gender"
                                            name='gender'
                                            value={gender}
                                            onChange={(e) => { setGender(e.target.value) }}
                                        >
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div className="mb-3 col-md-4">
                                        <label className="form-label">Civil status</label>
                                        <select className="form-control" id="civil_status">
                                            <option value="Married">Married</option>
                                            <option value="Single">Single</option>
                                            <option value="Divorced">Divorced</option>
                                            <option value="Widowed">Widowed</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div className="mb-3 col-md-4">
                                        <label className="form-label">Date of birth</label>
                                        <input type="date" className="form-control" placeholder="" id="datenaiss" />
                                    </div>
                                    <div className="mb-3  col-md-6">
                                        <label className="form-label">Phone</label>
                                        <input type="text" className="form-control" placeholder="" id="phone" />
                                    </div>
                                    <div className="mb-3  col-md-6">
                                        <label className="form-label">Adress Mail</label>
                                        <input type="email" className="form-control" placeholder="" id="email" />
                                    </div>
                                    <div className="mb-3 col-md-4">
                                        <label className="form-label">State/Province</label>
                                        <input type="text" className="form-control" placeholder="" id="stat-province" />
                                    </div>
                                    <div className="mb-3  col-md-4">
                                        <label className="form-label">City</label>
                                        <input type="text" className="form-control" placeholder="" id="city" />
                                    </div>
                                    <div className="mb-3  col-md-4">
                                        <label className="form-label">Street</label>
                                        <input type="text" className="form-control" placeholder="" id="street" />
                                    </div>
                                    <div className="mb-3  col-md-12">
                                        <label className="form-label">Adresse</label>
                                        <textarea className="form-control" placeholder=""
                                            id="adresse"></textarea>
                                    </div>
                                    <div className="col-md-12" id="error">

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-primary font-16 font-weight-500">Save changes</button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default SellerAccount
